function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { SubmissionError } from 'redux-form';

/**
 * Custom subclass of SubmissionError which allow us to pass extra information
 * Note: This is copied from 'js-utils/redux', originally we were importing it from there.
 * But that causes any app that uses 'js-utils/fetch' to be forced to take all of redux-form.
 */
export var CustomSubmissionError = function (_SubmissionError) {
    _inherits(CustomSubmissionError, _SubmissionError);

    function CustomSubmissionError(errors, extraData) {
        _classCallCheck(this, CustomSubmissionError);

        var _this = _possibleConstructorReturn(this, (CustomSubmissionError.__proto__ || Object.getPrototypeOf(CustomSubmissionError)).call(this, errors));

        _this.extraData = extraData;
        return _this;
    }

    return CustomSubmissionError;
}(SubmissionError);